import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import Button from "../../uiComponents/Button";
import { ModalContext } from "../../ModalContext";
import { deleteUser } from "../../../store/actions/user";

const DeleteProfModal = () => {
  const { t } = useTranslation();

  const { handleModal } = useContext(ModalContext);
  
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(deleteUser());
    handleModal();
  };

  return (
    <div>
      <p className="modal_title">
        {t('delete_profile_text')}
      </p>
      <div className="modal_btns">
        <Button transparent={true} clickFunction={() => handleModal(null)}>
          {t('cancel')}
        </Button>
        <Button clickFunction={handleClick}>{t('delete')}</Button>
      </div>
    </div>
  );
};

export default DeleteProfModal;
